import React, { Component } from "react";
import { HiMinusSm, HiPlus } from "react-icons/hi";
import { Modal, ModalBody } from "reactstrap";

class MinCountModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      count: 0,
    };
  }

  render() {
    return (
      <div>
        <Modal
          dir="rtl"
          zIndex="9999999"
          className="m-0"
          contentClassName="border-0 position-fixed fixed-bottom rounded-top-28 w-auto max-h-75"
          isOpen={this.props.minCountModal}
          toggle={() => this.props.changeModal(!this.props.minCountModal)}
        >
          <ModalBody className="row mx-0 p-4" style={{ flex: "unset" }}>
            <div className="col-12 px-0 fw-bold fs-5 mb-3">
              شرایط ارسال رایگان
            </div>
            <div className="col-12 px-0 fw-bold fs-5">
              <p className="text-secondary fw-bold fs-6">
                اگر تعداد اقلام سفارش بیشتر از
              </p>
            </div>
            <div className="col-12 px-0 position-relative mb-3 text-center">
              <span
                className="rounded28 border p-0 row mx-auto text-center w-75"
                style={{ height: "50px" }}
              >
                <button
                  className="btn col p-0 align-self-center color-second"
                  onClick={() => {
                    let old_count = this.state.count;
                    old_count++;
                    this.setState({ count: old_count });
                  }}
                >
                  <HiPlus size="40" />
                </button>

                <div className="col-auto px-0 align-self-center fs-3">
                  <span>{this.state.count}</span>
                </div>
                <button
                  className="btn col p-0 align-self-center color-second"
                  disabled={this.state.count < 1}
                  onClick={() => {
                    let old_count = this.state.count;
                    old_count--;
                    this.setState({ count: old_count });
                  }}
                >
                  <HiMinusSm size="40" />
                </button>
              </span>
            </div>
            <div className="col-12 px-0 fw-bold mt-3">
              <p className="text-secondary fw-bold fs-6">
                باشد، ارسال رایگان شود
              </p>
            </div>
            <div className="col-12 px-0 fw-bold fs-5 mt-4">
              <button
                onClick={() => {
                  this.props.setCount(this.state.count);
                  this.props.changeModal(false);
                }}
                className="btn px-3 py-2-3 bg-disabled w-100 bg-color-main fw-bold rounded28 text-white"
              >
                ثبت
              </button>
            </div>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

export default MinCountModal;
